import { Box } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import apiUtil from "../../api/apiUtil";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../components/Table/Table";
import "./promotion.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import CustomButton from "../../components/CustomButton/custombutton";
import * as Yup from "yup";
import FileUpload from "../../components/FileUpload/FileUpload";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import api from "../../api/api";
import getToken from "../getToken";
import img_coming_soon from "../../images/icons/coming_soon.png";
import DateFilter from "../../components/DateFilter/DateFilter";
import { format } from "date-fns";

const Promotion = () => {
  const [showAddPromotion, setShowAddPromotion] = useState(false);
  const [showEditPromotion, setShowEditPromotion] = useState(false);
  const refPromotionTable = useRef();
  const refPreviewPromotionFiles = useRef(false);
  const refPromotionListForm = useRef(null);
  const refSelectCategory = useRef();
  const [keyword, setKeyword] = useState("");
  const [filterDate, setFilterDate] = useState(null);
  const promotionId = useRef(0);

  const [showIsRoom, setShowIsRoom] = useState(false);
  const [menuCategoryDataList, setMenuCategoryDataList] = useState([]);
  let orgLevel = localStorage.getItem("orgLevel");

  const clickAddPromotion = (e) => {
    e.stopPropagation();
    if (showEditPromotion) {
      setShowEditPromotion(false);
      setTimeout(() => setShowAddPromotion(true), 100);
    } else {
      setShowAddPromotion(true);
    }
    setPromotionDetail({});
  };

  const clickBtnClose = () => {
    setShowAddPromotion(false);
    setShowEditPromotion(false);
  };

  const clickDeletePromotion = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this item?")) {
      api
        .post(`Admin/DeletePromotion?PromotionId=${rowData.id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Promotion deleted successfully!");
                retrievePromotionList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  const AddPromotionFormValidation = (showIsRoom) =>
    Yup.object().shape({
      name: Yup.string().nullable().required("Please enter the name."),
      date: Yup.array().required("Please enter the date."),
      price: Yup.string().nullable().required("Please enter the price."),
      image: Yup.mixed().required("Please choose the image."),
      description: Yup.string().required("Please enter the description."),
      roomId: Yup.string().when([], {
        is: () => showIsRoom,
        then: Yup.string().nullable().required("Please select a room."),
        otherwise: Yup.string().nullable(),
      }),
    });

  const [promotionList, setPromotionList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  const [param, setParam] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    brandId: brandId,
    filterDate: null,
  });

  const retrievePromotionList = (value = param) => {
    value.keyword = keyword || "";
    value.filterDate = filterDate;
    setPromotionList({
      ...promotionList,
      isLoading: true,
    });

    api
      .post("Admin/GetPromotionListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setPromotionList({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
            } else {
              setPromotionList({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            alert(error);
          }
        );
      });
  };
  console.log(promotionList);

  const handleSubmit = (values, actions) => {
    const promotion = {
      brandId: brandId,
      name: values.name,
      description: values.description,
      startDate: format(new Date(values.date[0].startDate), "yyyy-MM-dd"),
      endDate: format(new Date(values.date[0].endDate), "yyyy-MM-dd"),
      image: values.image.replace(/^data:(.*,)?/, ""),
      roomId: values.roomId,
      price: values.price,
    };
    console.log(promotion);

    api.post("Admin/CreatePromotion", promotion, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.value.code === 200) {
            alert("Promotion saved successfully!!");
            // reset the inputs and clear values
            actions.resetForm();
            // refSelectCategory.current.clearValue();
            values = {};
            setShowAddPromotion(false);
            retrievePromotionList();
            for (let i = 0; i < refPromotionListForm.current.length - 2; i++) {
              refPromotionListForm.current[i].value = "";
            }
            refPreviewPromotionFiles.current = false;
            //refresh menu list
            retrievePromotionList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };

  const [promotionDetail, setPromotionDetail] = useState({
    name: "",
    date: null,
    image: "",
    description: "",
    roomId: "",
    price: "",
  });

  const clickBtnEditPromotion = (e, id) => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
    e.stopPropagation();
    clickBtnClose();
    getPromotionDetail(id);
  };

  const getPromotionDetail = (id) => {
    api
      .get("Admin/GetPromotionDetail", { PromotionId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setPromotionDetail(response.data.value.data);
              refPreviewPromotionFiles.current = true;
              setShowEditPromotion(true);
              promotionId.current = id;
              if (response.data.value.data.roomId != null) {
                setShowIsRoom(true);
              } else {
                setShowIsRoom(false);
              }
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };
  console.log(promotionDetail);

  const editPromotionSubmit = (values, actions) => {
    const promotion = {
      id: promotionId.current,
      brandId: brandId,
      name: values.name,
      description: values.description,
      startDate: format(new Date(values.date[0].startDate), "yyyy-MM-dd"),
      endDate: format(new Date(values.date[0].endDate), "yyyy-MM-dd"),
      image: values.image.replace(/^data:(.*,)?/, ""),
      roomId: showIsRoom ? values.roomId : null,
      price: values.price,
    };
    console.log(promotion);

    api.post("Admin/UpdatePromotion", promotion, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.value.code === 200) {
            alert("Promotion updated successfully!!");
            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowEditPromotion(false);
            retrievePromotionList(param);
          } else {
            alert(response.data.value.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSubmitting(false);
  };

  const handleSendPromo = (rowData) => {
    console.log(rowData);

    api
      .post(
        `Admin/SendPromoToMembers?PromotionId=${rowData.id}`,
        {},
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.statusCode === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.statusCode === 200) {
              if (response.data.value.data == "True") {
                alert("Sent Notification Successfully!");
              } else {
                alert("Failed to send notification. Please reduce message size.");
              }
              console.log(response.data);
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            alert(error);
          }
        );
      });
  };

  const labelMap = {
    1: "Room List",
    2: "Service List",
    3: "Menu List",
  };
  const label = labelMap[orgLevel] || "";

  const placeholderMap = {
    1: "Select Room List",
    2: "Select Service List",
    3: "Select Menu List",
  };

  const placeholder = placeholderMap[orgLevel] || "";

  const bindAPIMenuCategoryList = () => {
    api
      .post(
        "Admin/GetProductList",
        {
          rowLimit: 10,
          currentPage: 1,
          brandId: brandId,
        },
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              if (response.data.data != null) {
                setMenuCategoryDataList(response.data.data.data);
              }
            } else {
              setMenuCategoryDataList({
                isLoading: false,
                grouping: false,
                limit: apiUtil.getDefaultPageSize(),
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };
  console.log(menuCategoryDataList);

  const menuCategorySelectList = () => {
    return menuCategoryDataList.map((mc) => ({
      label: mc.title,
      value: mc.id,
    }));
  };

  useEffect(() => {
    retrievePromotionList();
  }, [param, filterDate]);

  useEffect(() => {
    bindAPIMenuCategoryList();
  }, []);

  console.log(promotionList);

  return (
    <>
      {(showAddPromotion || showEditPromotion) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Promotion</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          <Formik
            initialValues={{
              name: promotionDetail.name ? promotionDetail.name : "",
              date:
                promotionDetail.startDate || promotionDetail.endDate
                  ? [
                    {
                      startDate: new Date(promotionDetail.startDate),
                      endDate: new Date(promotionDetail.endDate),
                      key: "selection",
                    },
                  ]
                  : "",
              price: promotionDetail.price ? promotionDetail.price : "",
              image:
                promotionDetail.image != null ? promotionDetail.image : null,
              description: promotionDetail.description
                ? promotionDetail.description
                : "",
              roomId: promotionDetail.roomId ? promotionDetail.roomId : null,
            }}
            enableReinitialize={true}
            validateOnBlur={false}
            validationSchema={AddPromotionFormValidation(showIsRoom)}
            onSubmit={(values, actions) => {
              if (showEditPromotion) {
                editPromotionSubmit(values, actions);
              } else {
                handleSubmit(values, actions);
              }
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form
                ref={refPromotionListForm}
                className="row form-container promotion-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="Enter Promotion"
                  />
                </div>

                <div className="col-6 mt-2">
                  <DateRangePicker
                    name="date"
                    label="Date"
                    customclass="input_wrapper"
                  />
                </div>

                <div className="col-6 mt-2">
                  <FileUpload
                    label="Image"
                    name="image"
                    handleFile={(file) => {
                      if (file.length > 0) {
                        const reader = new FileReader();
                        refPreviewPromotionFiles.current = true;

                        reader.onload = () => {
                          if (typeof reader.result === "string") {
                            const encoded_image = reader.result;
                            setFieldValue("image", encoded_image);
                          } else {
                            console.error(
                              "Error: FileReader result is not a string."
                            );
                          }
                        };
                        reader.readAsDataURL(file[0]);
                      }
                    }}
                    refPreviewFiles={refPreviewPromotionFiles}
                  />
                </div>

                <div className="col-6 mt-2">
                  <CustomInput
                    name="price"
                    type="number"
                    label="Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="Enter Price"
                    icontext="MMK"
                  />
                </div>

                <div className="col-12 mt-4">
                  <CustomInput
                    name="description"
                    label="Description"
                    textarea="true"
                  />
                </div>

                <div className="col-6 mt-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="room"
                      name="room"
                      className="form-check-input"
                      checked={showIsRoom}
                      onChange={() => {
                        setShowIsRoom(!showIsRoom);
                      }}
                    />
                    <label htmlFor="room" className="form-check-label">
                      Room Type
                    </label>
                  </div>
                </div>

                {showIsRoom ? (
                  <div className="col-12 mt-2">
                    <CustomSelect
                      options={menuCategorySelectList()}
                      name="roomId"
                      label={label}
                      isClearable={false}
                      placeholder={placeholder}
                      refSelect={refSelectCategory}
                    />
                  </div>
                ) : null}

                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddPromotion ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Promotion</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <DateFilter filterDate={filterDate} setFilterDate={setFilterDate} />
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrievePromotionList()}
          />
          {!showAddPromotion && (
            <CustomButton
              icon={add}
              text="Add Promotion"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddPromotion(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container promotion_table">
        <Table
          key={promotionList.total}
          ref={refPromotionTable}
          maxBodyHeight={promotionList.limit * 80}
          isLoading={promotionList.isLoading}
          grouping={promotionList.grouping}
          limit={promotionList.limit}
          page={promotionList.page}
          total={promotionList.total}
          data={promotionList.data}
          onPageChange={(page) => {
            setParam({
              ...param,
              currentPage: page,
            });
            retrievePromotionList(param);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (promotionList.page - 1) * promotionList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.image == null || row.image == "") {
                  row.image = img_coming_soon;
                }
                return (
                  <img
                    src={row.image}
                    alt=""
                    className="d-block imgPromotion"
                    onError={(e) => (e.target.src = img_coming_soon)}
                  />
                );
              },
              width: "160px",
            },
            {
              title: "Name",
              render: (row) => {
                if (row.name.length > 40) {
                  return row.name.substring(0, 39) + "...";
                }
                return row.name;
              },
              width: "160px",
            },
            {
              title: "Price",
              render: (row) => {
                return row.price !== null ? row.price + " MMK" : "-";
              },
              width: "160px",
            },
            {
              title: "Start Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.startDate);
              },
              width: "130px",
            },
            {
              title: "End Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.endDate);
              },
              width: "130px",
            },
            {
              title: "Description",
              render: (row) => {
                if (row.description.length > 40) {
                  return row.description.substring(0, 39) + "...";
                }
                return row.description;
              },
              width: "180px",
            },
            {
              title: "Promo Noti",
              render: (row) => {
                return (
                  <div>
                    <CustomButton
                      onClick={() => handleSendPromo(row)}
                      text="Send"
                      addIcon={false}
                      className="btnSendNoti"
                    />
                  </div>
                );
              },
              align: "center",
              width: "137px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickBtnEditPromotion(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDeletePromotion(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default Promotion;
